import React from "react";

const WebDevelopment = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-center py-5">Web Development</h1>
    </div>
  );
};

export default WebDevelopment;
